<template>
  <main :class="page_css_class">

    <div class="breadcrumbs" v-if="!is_advanced_page">
      <a class="breadcrumbs__link" href="/">Home</a>
      <div class="breadcrumb__divider" v-if="page_title.length > 0"></div>
      <div class="breadcrumbs__text">{{ page_title }}</div>
    </div>

    <div :class="{ 'page__container' : !is_advanced_page}" id="html_content">

    </div>
  </main>
</template>


<script>

import {
  onMounted, ref, h, createApp, compile, defineComponent, nextTick, render, createVNode
} from 'vue/dist/vue.esm-bundler';
import ContentPage from "../../models/ContentPage";
import Accordion from '../../directives/accordion';
import Opportunities from "../../components/public/opportunities";
import Calendly from "../../components/public/calendly";
import Page from "../../models/Page";
import API from "../../services/api";

export default {
  data: function() {
    return {
      html_content: "",
      css_content: ".red{color:red;}",
      is_advanced_page: false,
      page_title: ""
    }
  },
  computed:{
    full_path(){
      return this.$route.fullPath;
    },
    page_css_class(){
      return this.is_advanced_page ? 'layout-page' : 'page content-page'
    }
  },
  created(){
    console.log("...page");
  },
  mounted() {
    this.loadContentPage();
  },
  watch:{
    full_path(new_value){
      this.loadContentPage();
    }
  },
  methods: {
    loadContentPage(){
     // console.log("p", this.full_path);
      ContentPage.getByPath(this.full_path.split("?")[0]).then( page => {
       // console.log("page", page);

        let html_content = `<div class="page__header"><h1 class="page__heading">Page Not Found</h1></div><div>Return to <a href="/">home</a></div>`;
        this.is_advanced_page = false;
        this.page_title = "";

        if(page != null && page.active) {
          this.page_title  = page.title;
          html_content =  page.html;
          this.is_advanced_page = page != null ? page.use_advanced_editor : false;

          if (!this.is_advanced_page) {
            html_content = `<div class="page__header"><h1 class="page__heading">${page.title}</h1></div>` + html_content
          }
        }
        const DynamicComponent = defineComponent({ template: html_content });
        const app = createApp(DynamicComponent);
        app.directive("accordion", Accordion);
        app.component("opportunities", Opportunities);
        app.component("calendly", Calendly);
        app.mount("#html_content");

        this.addStyles(page);
      });
    },
    addStyles(page){
      let style = document.head.querySelector('[data-editor-style]');
      style.innerHTML = page.use_advanced_editor ?  page.css : '';
    }
  }
}
</script>
